export default "__VITE_ASSET__419fc438__"